var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-one-component",class:{'video-one-component-active' : _vm.status},style:({
        width: _vm.width,
        height: _vm.height
    }),on:{"click":function($event){return _vm.clickVideo()}}},[_c('div',{staticClass:"video-one-component__image",style:({ 
            backgroundImage: ("url(" + _vm.imgLocal + ")"),
            backgroundPosition: 'center center', 
            backgroundSize: 'cover'
        })}),(_vm.textStatus)?_c('div',{staticClass:"video-one-component__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),(_vm.timecode)?_c('div',{staticClass:"video-one-component__timecode"},[_vm._v(" "+_vm._s(_vm.durationString)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }